"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_3 = require("react-redux");
var semantic_ui_react_11 = require("semantic-ui-react");
exports.SidebarMenu = function (_ref) {
    var items = _ref.items,
        pathname = _ref.pathname,
        Link = _ref.Link,
        visible = _ref.visible;

    var isActive = function isActive(item) {
        return item.exact ? pathname === item.path : pathname.startsWith(item.path);
    };
    var activeItem = items.find(function (item) {
        return isActive(item);
    }) || {};
    return React.createElement(semantic_ui_react_11.Sidebar, { as: semantic_ui_react_11.Menu, animation: "slide along", width: "thin", visible: visible, icon: "labeled", vertical: true, inverted: activeItem.inverted }, items.map(function (item) {
        var active = isActive(item);
        return React.createElement(semantic_ui_react_11.Menu.Item, { as: Link, to: item.path, active: active, key: item.path }, React.createElement(semantic_ui_react_11.Icon, { name: item.icon }), item.name);
    }));
};
var mapStateToProps = function mapStateToProps(state) {
    return {
        visible: state.isSidebarVisible
    };
};
exports.default = react_redux_3.connect(mapStateToProps)(exports.SidebarMenu);


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/opt/build/repo/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/components/SidebarMenu/SidebarMenu.tsx